import { HostCfgDTO, HostCfgsResponseDTO } from "@dto/hostCfgResponse.dto"
import { ImportResultRespnse, LparStorImportAuth } from "@dto/import.dto"
import { postApi } from "src/util/apiCalls"

enum IMPORT {
  URL = "/api/import/v1/import",
  FILE = "/api/import/v1/import/file",
  DISABLE_HOSTCFG = "/api/configuration/v1/hostcfg/disable",
  UPDATE_HOSTCFG_LABELS = "/api/configuration/v1/hostcfg/labels"
}


export const postDataDestinationsAPI = async (data: LparStorImportAuth) => {
  try {
    const response = await postApi<ImportResultRespnse, LparStorImportAuth>(
      IMPORT.URL,
      data
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const postFileDestinationsAPI = async (data: FormData
) => {
  try {
    const response = await postApi<ImportResultRespnse, FormData>(
      IMPORT.FILE,
      data
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const postDisableHostCfgsAPI = async (data: HostCfgDTO[]) => {
  try {
    const response = await postApi<HostCfgsResponseDTO, HostCfgDTO[]>(
      IMPORT.DISABLE_HOSTCFG,
      data
    );

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export const postUpdatedSwithcesAPI = async (data: HostCfgDTO[]) => {
  try {
    const response = await postApi<HostCfgsResponseDTO, HostCfgDTO[]>(
      IMPORT.UPDATE_HOSTCFG_LABELS,
      data
    );

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}